var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 10,
    viewBox: "0 0 15 10",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.49621 5.60007L0.654976 1.591C0.543556 1.52741 0.400391 1.591 0.400391 1.73416V9.17955C0.400391 9.46588 0.638992 9.70456 0.925415 9.70456L14.2579 9.7047C14.5283 9.7047 14.7352 9.49783 14.7352 9.22737V1.71831C14.7352 1.59104 14.592 1.51146 14.4806 1.57517L7.65529 5.60014C7.60755 5.63201 7.54392 5.63193 7.49621 5.60007Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4342 0H0.719883C0.560734 0 0.497143 0.206848 0.640316 0.286293L7.49745 4.34312C7.54517 4.37497 7.60887 4.37497 7.65659 4.34312L14.5137 0.286293C14.6409 0.190971 14.5773 0 14.4342 0Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/Message.c1e77bde6a25e44dbd12e20d4d465358.svg";
export { ForwardRef as ReactComponent };